"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
/**
 * [Model] RoleItem
 */
var RoleItem = exports["default"] = /*#__PURE__*/function () {
  function RoleItem() {
    (0, _classCallCheck2["default"])(this, RoleItem);
  }
  return (0, _createClass2["default"])(RoleItem, null, [{
    key: "parseV1",
    value:
    /**
     * Parse snake case data
     */
    function parseV1(data) {
      var rowData = data || {};
      var role = new RoleItem();
      role.id = rowData.ea_role_id || rowData.id;
      role.name = rowData.name;
      role.enName = rowData.en_name;
      role.oxygenId = rowData.oxygen_id;
      role.status = rowData.status;
      return role;
    }

    /**
     * Parse camel case data
     */
  }, {
    key: "parseV2",
    value: function parseV2(data) {
      var rowData = data || {};
      var role = new RoleItem();
      role.id = rowData.id;
      role.oxygenId = rowData.oxygenId;
      role.name = rowData.name;
      role.participated = rowData.participated;
      return role;
    }

    /**
     * Parse camel case data
     */
  }, {
    key: "parseHQ",
    value: function parseHQ(data) {
      var rowData = data || {};
      var role = new RoleItem();
      role.id = rowData.id;
      role.oxygenId = rowData.memberGroupId;
      role.name = rowData.name;
      role.status = rowData.status;
      return role;
    }
  }]);
}();